import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
// import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class DataWebServicesService {

    dwsURL: string = ''  ;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
    // private configService: ConfigService
  ) { 

		this.dwsURL = this.appConfigService.getDataWebServicesURL();
  }

  getService(service:string): Observable<any> {
    console.log(service);
		const httpOptions = {}; // { withCredentials: true };
    return this.http.get ( this.dwsURL + service, httpOptions);
  }
}
